<template>
  <div>
    <h3>{{ _('Route details') }}</h3>
    <div class="form-group">
      <label>{{ _('Path') }}</label>
      <input type="text" class="form-control" v-model="route['path']" />
    </div>
    <div class="form-group">
      <label>{{ _('Product') }}</label>
      <select class="form-control" v-model="selectedProduct">
        <option value="">{{ _('Not selected') }}</option>
        <option :value="product.id" v-for="product in products">{{ itemTitle(product) }}</option>
      </select>
    </div>
    <div class="form-group">
      <label>{{ _('Category') }}</label>
      <select class="form-control" v-model="selectedCategory">
        <option value="">{{ _('Not selected') }}</option>
        <option :value="category.id" v-for="category in categories">{{ itemTitle(category) }}</option>
      </select>
    </div>
    <div class="form-group">
      <label>{{ _('Template for products') }}</label>
      <select class="form-control" v-model="selectedProductTemplate">
        <option value="">{{ _('Not selected') }}</option>
        <option :value="template.id" v-for="template in templates">{{ itemTitle(template) }}</option>
      </select>
    </div>
    <div class="form-group">
      <label>{{ _('Template for categories') }}</label>
      <select class="form-control" v-model="selectedCategoryTemplate">
        <option value="">{{ _('Not selected') }}</option>
        <option :value="template.id" v-for="template in templates">{{ itemTitle(template) }}</option>
      </select>
    </div>
    <div class="form-group">
      <label><input type="checkbox" v-model="menu" /> {{ _('Show in menu') }}</label>
    </div>
    <div class="form-group">
      <label>{{ _('Type') }}</label>
      <select class="form-control" v-model="route.type">
        <option value="direct">{{ _('Direct') }}</option>
        <option value="link">{{ _('Link') }}</option>
      </select>
    </div>
    <div class="form-group" v-if="creationDate">
      <label>{{ _('Created') }}</label>
      <input type="text" class="form-control" :value="creationDate" disabled="disabled" />
    </div>
    <div class="form-group" v-if="updateDate">
      <label>{{ _('Updated') }}</label>
      <input type="text" class="form-control" :value="updateDate" disabled="disabled" />
    </div>
    <div class="form-group">
      <button class="btn btn-success" type="button" v-on:click="save"><i class="fa fa-fw fa-save"></i> {{ _('Save') }}</button>
      <button class="btn btn-default" type="button" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-danger" type="button" v-on:click="remove" v-if="route.id"><i class="fa fa-fw fa-trash"></i> {{ _('Delete') }}</button>
    </div>
    <pre v-if="false">
    {{ route }}
    </pre>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      route: { ...this.value }
    }
  },
  props: ['value', 'categories', 'products', 'templates'],
  computed: {
    ...mapGetters(['dateFormat', 'timeFormat', 'timezone']),
    creationDate () {
      return this.route && this.route.created ? DateTime.fromSeconds(Number(this.route.created), { zone: this.timezone }).toFormat(this.dateFormat + ' ' + this.timeFormat) : null
    },
    updateDate () {
      return this.route && this.route.updated ? DateTime.fromSeconds(Number(this.route.updated), { zone: this.timezone }).toFormat(this.dateFormat + ' ' + this.timeFormat) : null
    },
    menu: {
      get() {
        return !!this.route.menu
      },
      set(newValue) {
        this.route.menu = !!newValue
      }
    },
    selectedProduct: {
      get() {
        return this.route && this.route.product ? this.route.product.id : ''
      },
      set(newValue) {
        this.route.category = null
        let p = this.products.find((p) => p.id === newValue)
        if (p) {
          this.route.product = p
        }
      }
    },
    selectedCategory: {
      get() {
        return this.route && this.route.category ? this.route.category.id : ''
      },
      set(newValue) {
        this.route.product = null
        let c = this.categories.find((c) => c.id === newValue)
        if (c) {
          this.route.category = c
        }
      }
    },
    selectedProductTemplate: {
      get() {
        return this.route && this.route.productTemplate ? this.route.productTemplate.id : ''
      },
      set(newValue) {
        this.route.productTemplate = null
        let t = this.templates.find((t) => t.id === newValue)
        if (t) {
          this.route.productTemplate = t
        }
      }
    },
    selectedCategoryTemplate: {
      get() {
        return this.route && this.route.categoryTemplate ? this.route.categoryTemplate.id : ''
      },
      set(newValue) {
        this.route.categoryTemplate = null
        let t = this.templates.find((t) => t.id === newValue)
        if (t) {
          this.route.categoryTemplate = t
        }
      }
    }
  },
  methods: {
    itemTitle (item) {
      if (!this.route || !this.route.defaultLocale || !item || !item.locale || !item.locale[this.route.defaultLocale]) {
        return ''
      }
      return item.locale[this.route.defaultLocale].title
    },
    save () {
      this.$emit('input', this.route)
    },
    close () {
      this.$emit('close')
    },
    remove() {
      this.$emit('delete', this.route)
    }
  }
}
</script>